'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463 from "./presto.types$-Directive-Path$$anon$63.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464 from "./presto.types$-Directive-Path$$anon$64.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectivePath$() {
  this.c57 = null;
  this.c58 = false;
  this.c55 = null;
  this.c56 = false;
  this.c5b = null;
  this.c5c = false;
  this.c59 = null;
  this.c5a = false;
  this.c5d = null;
  this.c5e = false;
}
export { $c_Lpresto_types$DirectivePath$ as $c_Lpresto_types$DirectivePath$ };
$p = $c_Lpresto_types$DirectivePath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectivePath$;
/** @constructor */
function $h_Lpresto_types$DirectivePath$() {
}
export { $h_Lpresto_types$DirectivePath$ as $h_Lpresto_types$DirectivePath$ };
$h_Lpresto_types$DirectivePath$.prototype = $p;
$p.cHq = (function() {
  if ((!this.c58)) {
    this.c57 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c58 = true;
  }
  return this.c57;
});
$p.v7 = (function() {
  if ((!this.c56)) {
    this.c55 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c56 = true;
  }
  return this.c55;
});
$p.cIa = (function() {
  if ((!this.c5c)) {
    this.c5b = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5c = true;
  }
  return this.c5b;
});
$p.crH = (function() {
  if ((!this.c5a)) {
    this.c59 = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463.$c_Lpresto_types$DirectivePath$$anon$63(this);
    this.c5a = true;
  }
  return this.c59;
});
$p.cIq = (function() {
  if ((!this.c5e)) {
    this.c5d = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464.$c_Lpresto_types$DirectivePath$$anon$64(this);
    this.c5e = true;
  }
  return this.c5d;
});
var $d_Lpresto_types$DirectivePath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectivePath$, "presto.types$DirectivePath$", ({
  ZZ: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectivePath$ as $d_Lpresto_types$DirectivePath$ };
var $n_Lpresto_types$DirectivePath$;
function $m_Lpresto_types$DirectivePath$() {
  if ((!$n_Lpresto_types$DirectivePath$)) {
    $n_Lpresto_types$DirectivePath$ = new $c_Lpresto_types$DirectivePath$();
  }
  return $n_Lpresto_types$DirectivePath$;
}
export { $m_Lpresto_types$DirectivePath$ as $m_Lpresto_types$DirectivePath$ };
//# sourceMappingURL=presto.types$-Directive-Path$.js.map
